import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { notification, modal } from 'redux/modules/app'
import { notifications as notificationsApi } from 'redux/modules/api/combineDashboard'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        notificationsCount: get(api, 'dashboard.notifications.count'),
        notificationsData: get(api, 'dashboard.notifications.data'),
        notificationsLoading: get(api, 'dashboard.notifications.loading')
      }),
      {
        ...notificationsApi,
        notification,
        modal,
        push
      }
    )
    class apiNotification extends Component {
      static propTypes = {
        loadNotifications: PropTypes.func.isRequired,
        loadCount: PropTypes.func.isRequired,
        markAsReadBulk: PropTypes.func.isRequired
      }

      componentDidMount() {
        config.loadCount && this.props.loadCount()
      }

      handleLoadNotifications = () => this.props.loadNotifications()

      handleMarkAsRead = (notificationIds = []) => {
        if (notificationIds && notificationIds.length > 0) {
          const data = { notificationIds }

          this.props.markAsReadBulk(data)
        }
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onLoadNotifications={this.handleLoadNotifications}
            onMarkAsRead={this.handleMarkAsRead}
          />
        )
      }
    }
    return apiNotification
  }
}

export default decorator
